<template>
  <div class="loading-bar-wrapper">
    <div class="loading-bar-track">
      <div
        class="loading-bar-fill"
        :style="{ width: displayedPercentage + '%' }"
      ></div>
    </div>
    <div class="loading-bar-label">
      <span class="message-text">{{ message }}</span>
      <span class="percentage-text"
        >{{ Math.round(displayedPercentage) }}%</span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingBar',
  props: {
    message: {
      type: String,
      default: 'Returning answer..',
    },
    progressValue: {
      type: Number,
      required: true,
      validator: (v) => v >= 0 && v <= 1,
    },
  },
  data() {
    return {
      displayedValue: 0,
      animationFrame: null,
    };
  },
  computed: {
    displayedPercentage() {
      return this.displayedValue * 100;
    },
  },
  watch: {
    progressValue: {
      immediate: true,
      handler(newVal) {
        this.animateTo(newVal);
      },
    },
  },
  methods: {
    animateTo(target) {
      cancelAnimationFrame(this.animationFrame);

      const step = () => {
        const delta = target - this.displayedValue;
        const speed = 0.1;

        if (Math.abs(delta) < 0.001) {
          this.displayedValue = target;
          return;
        }

        this.displayedValue += delta * speed;
        this.animationFrame = requestAnimationFrame(step);
      };

      step();
    },
  },
  beforeDestroy() {
    cancelAnimationFrame(this.animationFrame);
  },
};
</script>

<style scoped>
.loading-bar-wrapper {
  position: relative;
  width: 100%;
  padding: 10px 10px 15px 10px;
  background-color: #f4f4f8;
}

.loading-bar-track {
  position: relative;
  width: 100%;
  height: 22px;
  background-color: #e0d7f3;
  border-radius: 11px;
  overflow: hidden;
  margin: 0 auto;
  max-width: 90%;
}

.loading-bar-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, #6a0dad 0%, #8b5cf6 100%);
  border-radius: 11px;
  transition: width 0.3s ease;
}

.loading-bar-label {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -52%);
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8), 0 -1px 2px rgba(0, 0, 0, 0.8),
    1px 0 2px rgba(0, 0, 0, 0.8), -1px 0 2px rgba(0, 0, 0, 0.8);
  pointer-events: none;
  white-space: nowrap;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.message-text {
  display: inline-block;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 4px;
}
</style>
